import { createSelector } from '@reduxjs/toolkit';
import { WebRootState } from '@website/store/web-store';
import { SessionEvent } from '../../../common/models/session-event';
import { EntityState } from '@reduxjs/toolkit';

interface SessionEventsState extends EntityState<SessionEvent> {
  itemsLoading: boolean;
  itemsLoaded: boolean;
  total: number;
  skip: number;
  limit: number;
}

interface GroupedEvents {
  [key: string]: {
    latestEvent: SessionEvent;
    events: SessionEvent[];
  };
}

const getSessionEventsState = (state: WebRootState) => state.DBSessionEventsReducer as SessionEventsState;

export const selectPaginationStatus = createSelector(
  [getSessionEventsState],
  (state) => ({
    itemsLoading: state.itemsLoading,
    itemsLoaded: state.itemsLoaded,
    total: state.total,
    skip: state.skip,
    limit: state.limit
  })
);

export const selectSessionEventsBySessionId = createSelector(
  [getSessionEventsState, (_state: WebRootState, sessionId?: string) => sessionId],
  (state, sessionId) => {
    if (!sessionId) return [];
    return Object.values(state.entities).filter(event => event && event.sessionId === sessionId);
  }
);

export const sessionEventsSelectors = {
  selectPaginationStatus,
  selectSessionEventsBySessionId,
}; 